import ApplicationPortal from "./ApplicationPortal"
export default ApplicationPortal
